import Validator from 'validatorjs';
import { expirationDateValidator, creditCardValidator } from './index';

export const cardNumberValidator = (num = '') => creditCardValidator(num) === null;

export const cardDateValidator = (date = '') => expirationDateValidator(date) === null;

/**
 * Registers a card expiration validator.
 */
Validator.register('card_expiration', cardDateValidator, 'The :attribute is invalid.');

/**
 * Registers a card number validator.
 */
Validator.register('card_number', cardNumberValidator, 'The :attribute is invalid.');
